import { render, staticRenderFns } from "./CurrencyChose.vue?vue&type=template&id=ff54109e&scoped=true"
import script from "./CurrencyChose.vue?vue&type=script&lang=js"
export * from "./CurrencyChose.vue?vue&type=script&lang=js"
import style0 from "./CurrencyChose.vue?vue&type=style&index=0&id=ff54109e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff54109e",
  null
  
)

export default component.exports